import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38a67d5f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "expedients" }
const _hoisted_2 = {
  key: 0,
  class: "h-100 w-100 d-flex align-items-center justify-content-center"
}
const _hoisted_3 = { class: "h5 title fw-bold text-primary" }
const _hoisted_4 = {
  key: 1,
  class: "scroll-component-container"
}
const _hoisted_5 = { class: "scroll-component" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-center icon-section" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "icon icon-user-circle",
    title: "En persona",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_7 = { class: "d-flex flex-column align-items-start" }
const _hoisted_8 = { class: "name text-tertiary fw-bold mb-8" }
const _hoisted_9 = { class: "name fw-normal" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-center ms-auto ps-8" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "icon icon-expand-right text-primary",
    "aria-hidden": "true"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_loader = _resolveComponent("v-loader")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.status === 'loading')
      ? (_openBlock(), _createBlock(_component_v_loader, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (!_ctx.expedients.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('No tienes ningún paciente')), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expedients, (expedient, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "item p-8",
                      key: index
                    }, [
                      (_ctx.can('professional.expedient.show'))
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: {name: 'professional.expedient.show', params: {
                expedient:  expedient.id, tabName: 'general'
              }},
                            class: "btn btn-icon d-flex align-items-center item-content btn-sm p-0 justify-content-center",
                            "aria-label": _ctx.$t('Ver expediente')
                          }, {
                            default: _withCtx(() => [
                              _hoisted_6,
                              _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, _toDisplayString(expedient.patient.user.name) + " " + _toDisplayString(expedient.patient.user.surname), 1),
                                _createElementVNode("div", _hoisted_9, _toDisplayString(expedient.patient.nif), 1)
                              ]),
                              _hoisted_10
                            ]),
                            _: 2
                          }, 1032, ["to", "aria-label"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]))
        ], 64))
  ]))
}